import { Injectable } from '@angular/core';

// Services
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(
    private _httpService: HttpService
  ) { }

  getListCategories(data: any) {
    let headers: any = {
      'dataCategoriaProductos': 'true',
      'dataCliente': 'true',
      'dataEmpresa': 'true',
      'modality': data.modality,
      'tableNumber': data.table ?? '1'
    }
    if (localStorage.getItem('client_categories') != null || localStorage.getItem('client_categories') != undefined) {
      headers.categoryId = localStorage.getItem('client_categories');
    }
    if (localStorage.getItem('latitude') && localStorage.getItem('latitude') != '0' && localStorage.getItem('latitude') != '') {
      headers.latitude = localStorage.getItem('latitude');
    }
    if (localStorage.getItem('longitude') && localStorage.getItem('longitude') != '0' && localStorage.getItem('longitude') != '') {
      headers.longitude = localStorage.getItem('longitude');
    }
    return this._httpService.httpGet(`ecommerce/cliente/${data.client}/empresa/${data.company}`, headers);
    // return this._httpService.httpGet(`clientes/cliente/${id}`, headers);
  }
}
